export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[640px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20stylized%20abstract%20digital%20media%20collage%20with%20warm%20orange%20red%20gradient%20accents%2C%20geometric%20overlapping%20shapes%2C%20modern%20news%20media%20aesthetic%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%2C%20entertainment%20industry%20visual%20theme%2C%20no%20text%2C%20no%20people%20faces%2C%20bold%20dynamic%20composition&width=1600&height=900&seq=hero-bg-17chigua&orientation=landscape"
          alt="17吃瓜网 - 最新吃瓜视频平台"
          className="w-full h-full object-cover"
          onError={(e) => {
            (e.target as HTMLElement).style.display = 'none';
          }}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/85 via-foreground-950/70 to-foreground-950/80"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-500/20 border border-primary-400/30 rounded-full px-4 py-1.5 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
              <span className="text-primary-300 text-sm font-medium">实时更新 · 每日新鲜吃瓜</span>
            </div>

            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-4">
              17吃瓜网 · 你的在线吃瓜第一站
            </h1>

            <p className="text-background-200/80 text-sm md:text-base leading-relaxed max-w-xl lg:max-w-none mb-4">
              17吃瓜网专注收集全网最新黑料吃瓜视频与爆料视频，覆盖网红动态、吃瓜现场实拍、热门黑料深扒等多元内容。每日更新精选吃瓜视频，从娱乐圈内幕到网红翻车现场，一站看全最新最热的吃瓜黑料视频，让你不错过任何一个精彩瞬间。当前热门专题聚焦网红爆料追踪与现场实拍合集，持续为吃瓜爱好者带来真实、快速、全面的在线观看体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-6">
              <div className="text-center">
                <div className="text-accent-400 font-heading font-bold text-xl md:text-2xl">10,000+</div>
                <div className="text-background-300/80 text-xs mt-0.5">吃瓜视频资源</div>
              </div>
              <div className="w-px h-8 bg-background-300/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-accent-400 font-heading font-bold text-xl md:text-2xl">每日更新</div>
                <div className="text-background-300/80 text-xs mt-0.5">新鲜爆料不停歇</div>
              </div>
              <div className="w-px h-8 bg-background-300/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-accent-400 font-heading font-bold text-xl md:text-2xl">全品类覆盖</div>
                <div className="text-background-300/80 text-xs mt-0.5">网红·娱乐·社会</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看热门视频
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-background-300/30 hover:border-background-300/60 text-background-100 hover:text-background-50 font-medium px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-100/10 border border-background-200/15">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20entertainment%20news%20collage%20with%20play%20button%20overlay%2C%20warm%20dark%20tone%20with%20red%20orange%20highlight%2C%20digital%20media%20abstract%20composition%2C%20cinematic%20vibe%2C%20modern%20video%20platform%20aesthetic%2C%20no%20recognizable%20faces%2C%20geometric%20design%20elements&width=800&height=600&seq=hero-side-17chigua&orientation=landscape"
                alt="17吃瓜网视频专区预览"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary-500/90 flex items-center justify-center cursor-pointer hover:bg-primary-400 transition-colors">
                  <i className="ri-play-fill text-3xl md:text-4xl text-background-50 ml-1"></i>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-4">
                <p className="text-background-100 text-sm font-medium">最新热点：网红爆料追踪专题</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}